import { ModuleWithProviders, NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { FileInputComponent } from './components/file-input/file-input.component';
import { FileViewComponent } from './components/file-view/file-view.component';
import { PaginatorComponent } from './components/paginator/paginator.component';
import { SearchComponent } from './components/search/search.component';
import { SelectComponent } from './components/select/select.component';
import { TitleComponent } from './components/title/title.component';
import { PropertyService } from './services/property.service';
import { SupportService } from './services/support.service';
import { TwoLineSelectComponent } from './components/two-line-select/two-line-select.component';
import { CsvUploadComponent } from './components/csv-upload/csv-upload.component';
import { LeaseTermPipe } from './pipes/lease-term.pipe';
import { ApplicationStatusPipe } from './pipes/application-status.pipe';
import { AuthorizePolicyGuard } from './guards/authorize-policy.guard';
import { ProductBadgeComponent } from './components/product-badge/product-badge.component';
import { CopyElementComponent } from './components/copy-element/copy-element.component';
import { ResidentStatusBadgeComponent } from './components/resident-status-badge/resident-status-badge.component';
import { ApplicationGlobalStatusPipe } from './pipes/application-global-status.pipe';
import { ApplicationStatusBadgeComponent } from './components/application-status-badge/application-status-badge.component';
import { ClaimStatusBadgeComponent } from './components/claim-status-badge/claim-status-badge.component';
import { RenewalBadgeComponent } from './components/renewal-badge/renewal-badge.component';
import { ContactDialogComponent } from './components/contact-support-dialog/contact-dialog.component';

@NgModule({
  imports: [
    SharedModule
  ],
  declarations: [
    PaginatorComponent,
    SearchComponent,
    SelectComponent,
    TitleComponent,
    FileInputComponent,
    FileViewComponent,
    TwoLineSelectComponent,
    CsvUploadComponent,
    LeaseTermPipe,
    ApplicationStatusPipe,
    ProductBadgeComponent,
    CopyElementComponent,
    ResidentStatusBadgeComponent,
    ApplicationGlobalStatusPipe,
    ApplicationStatusBadgeComponent,
    ClaimStatusBadgeComponent,
    RenewalBadgeComponent,
    ContactDialogComponent
  ],
  exports: [
    SharedModule,
    PaginatorComponent,
    SearchComponent,
    SelectComponent,
    TitleComponent,
    FileInputComponent,
    FileViewComponent,
    TwoLineSelectComponent,
    CsvUploadComponent,
    LeaseTermPipe,
    ApplicationStatusPipe,
    ProductBadgeComponent,
    CopyElementComponent,
    ResidentStatusBadgeComponent,
    ApplicationGlobalStatusPipe,
    ApplicationStatusBadgeComponent,
    ClaimStatusBadgeComponent,
    RenewalBadgeComponent,
    ContactDialogComponent
  ]
})
export class CommonModule {
  static forRoot(): ModuleWithProviders<CommonModule> {
    return {
      ngModule: CommonModule,
      providers: [
        PropertyService,
        SupportService,
        AuthorizePolicyGuard
      ]
    };
  }
}
